import React from 'react';
import { motion } from 'framer-motion';
const solutions = [{
  emoji: '🏡',
  text: 'Vas a entrar a ese ambiente que hoy evitás y sentir orgullo genuino al ver que por fin se ve moderno y actual.'
}, {
  emoji: '🧠',
  text: 'Vas a dejar de mirar tu casa con frustración y empezar a tomar decisiones seguras porque sabés exactamente qué hacer.'
}, {
  emoji: '✨',
  text: 'Vas a conseguir un antes y después visible en pocas horas, sin polvo, sin desorden y sin que tu rutina se descontrole.'
}, {
  emoji: '💸',
  text: 'Vas a recuperar el control sobre tu dinero al modernizar tu casa sin gastar fortunas ni depender de presupuestos impagables.'
}, {
  emoji: '😌',
  text: 'Vas a sentir la tranquilidad de vivir en un espacio que te representa hoy, sin pasar meses soportando una obra interminable.'
}];
export function Solutions() {
  return <section className="py-8 md:py-12 px-4 md:px-6 lg:px-8 bg-white" data-id="element-174">
      <div className="max-w-3xl mx-auto" data-id="element-175">
        <div className="text-center mb-5" data-id="element-176">
          <h2 className="text-xl md:text-2xl font-black text-black tracking-tight" data-id="element-177">
            ¿Qué Lograrás Con Este Sistema?
          </h2>
        </div>

        <div className="flex flex-col gap-2" data-id="element-178">
          {solutions.map((solution, index) => {
          const words = solution.text.split(' ');
          const boldPart = words.slice(0, 4).join(' ');
          const restPart = words.slice(4).join(' ');
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className="bg-lightgray p-3 rounded-lg border-l-4 border-orange flex items-start gap-2.5" data-id="element-179">
                <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-180">
                  {solution.emoji}
                </span>
                <p className="text-black/90 font-medium leading-snug text-sm" data-id="element-181">
                  <span className="font-bold" data-id="element-182">{boldPart}</span> {restPart}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}